import {Component, Fragment} from 'react';
import {Animated, ScrollView, View} from 'react-native';
import Drawer from 'react-modern-drawer';
import 'react-modern-drawer/dist/index.css';

import type {DrawerLayoutProps, DrawerLayoutState} from 'react-native-gesture-handler/DrawerLayout';

export class DrawerLayout extends Component<DrawerLayoutProps> {
  constructor(props: DrawerLayoutProps) {
    super(props);
    this.state = {
      dragX: new Animated.Value(0),
      touchX: new Animated.Value(0),
      drawerTranslation: new Animated.Value(0),
      containerWidth: props.drawerWidth || 300,
      drawerState: 'Idle',
      drawerOpened: false,
    } satisfies DrawerLayoutState;
  }

  onDrawerOpen = () => {
    this.setState({drawerOpened: true});
    if (this.props.onDrawerOpen) {
      this.props.onDrawerOpen();
    }
  };

  onDrawerClose = () => {
    this.setState({drawerOpened: false});
    if (this.props.onDrawerClose) {
      this.props.onDrawerClose();
    }
  };

  openDrawer = () => {
    this.onDrawerOpen();
  };

  closeDrawer = () => {
    this.onDrawerClose();
  };

  render() {
    const {drawerOpened, drawerTranslation, containerWidth} = this.state as DrawerLayoutState;
    const {children, renderNavigationView, drawerPosition} = this.props;

    return (
      <View style={{flex: 1}}>
        <Drawer
          open={drawerOpened}
          direction={drawerPosition}
          onClose={this.closeDrawer}
          style={{width: containerWidth}}>
          {renderNavigationView(drawerTranslation)}
        </Drawer>
        {children}
      </View>
    );
  }
}